import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import InfoCircleIcon from '../../../../components/icons/InfoCircleIcon';

const propTypes = {
  className: PropTypes.string,
  linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  icon: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltipId: PropTypes.string,
  tooltipPlace: PropTypes.string,
};

const ListingCardInline = ({
  className,
  linkTo = '',
  icon,
  title,
  children,
  disabled,
  onClick,
  tooltip,
  tooltipId,
  tooltipPlace = 'top',
  ...props
}) => {
  const classes = classNames({
    'listing-card-inline': true,
    'is-disabled': disabled,
    [className]: !!className,
  });

  return (
    <Link
      to={linkTo}
      className={classes}
      onClick={event => {
        if (disabled) {
          event.preventDefault();
        }

        onClick?.(event);
      }}
      {...props}
    >
      {icon && <span className="listing-card-inline-icon">{icon}</span>}
      {title && <p className="listing-card-inline-title">{title}</p>}
      {tooltipId && (
        <div className="listing-card-inline-subtitle-bubble">
          <InfoCircleIcon
            size={30}
            data-tip
            data-for={tooltipId}
            data-effect="solid"
            data-place={tooltipPlace}
          />
          <ReactTooltip id={tooltipId}>{tooltip}</ReactTooltip>
        </div>
      )}

      {children}
    </Link>
  );
};

ListingCardInline.propTypes = propTypes;

export default ListingCardInline;
